module.exports = __webpack_public_path__ + "static/nyc-view-6c922b601d3cbaf0f9b67d6aee29356a.png";